import type { NavigateOptions, To } from "react-router";
import { useLocation, useNavigate } from "react-router";

/**
 * Drop-in replacement for useNavigate that automatically stores the current
 * location as `state.from` on every programmatic navigation. This enables
 * BackButton to show a context-aware label ("Zpět na klienta" etc.) without
 * any extra work at each call site.
 *
 * Navigation with a numeric delta (e.g. navigate(-1)) is passed through
 * unchanged — history-based back/forward doesn't need the from annotation.
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return (to: To | number, options?: NavigateOptions): void => {
    if (typeof to === "number") {
      navigate(to);
    } else {
      navigate(to, {
        ...options,
        state: {
          ...options?.state,
          from: location,
        },
      });
    }
  };
}
